export default "__VITE_ASSET__B85zLxaB__"